import EditorField from "../../Utils/EditorField"
import { careerProfileLabels } from "../../Types/careerProfileLabels"
const CognitiveHealth = ({ formik }) => {
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <EditorField
          value={formik.values.cognitive_1}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.cognitiveHealth.cognitiveHealth_1.value
          }
          label={careerProfileLabels.cognitiveHealth.cognitiveHealth_1.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.cognitive_2}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.cognitiveHealth.cognitiveHealth_2.value
          }
          label={careerProfileLabels.cognitiveHealth.cognitiveHealth_2.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.cognitive_3}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.cognitiveHealth.cognitiveHealth_3.value
          }
          label={careerProfileLabels.cognitiveHealth.cognitiveHealth_3.label}
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.cognitive_4}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.cognitiveHealth.cognitiveHealth_4.value
          }
          label={careerProfileLabels.cognitiveHealth.cognitiveHealth_4.label}
        />
      </div>
    </>
  )
}
export default CognitiveHealth
